package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PortfolioHistoryEntryDto(
    @SerialName("date") val date: String,
    @SerialName("value") val value: Double
)

@Serializable
data class PortfolioHistoryResponse(
    @SerialName("history") val history: List<PortfolioHistoryEntryDto>
)

@Serializable
data class SecurityPerformanceResponse(
    @SerialName("history") val history: Map<String, List<PortfolioHistoryEntryDto>>
)

@Serializable
data class PlaidPricesSyncResponse(
    @SerialName("job_id") val jobId: String?,
    @SerialName("tickers") val tickers: List<String>,
    @SerialName("source") val source: String,
    @SerialName("status") val status: String
)
